// Hợp đồng API của «Phân tích kênh văn phòng» — kênh CỦA CÔNG TY đo bằng thước đo của mục Nghiên cứu đối thủ.
import { z } from 'zod';
/**
 * PHÂN TÍCH KÊNH VĂN PHÒNG (06/10/2026, chủ dự án: «Thiết kế 1 chức năng Phân tích, nghiên cứu kênh từng văn
 * phòng: nó giống như phân tích kênh đối thủ, nhưng thay thế nhóm đối thủ tôi cần gom nhóm từng văn phòng, nhóm,
 * nhân viên»).
 *
 * Kênh công ty (bản ghi `channel` ở Thông tin kênh) được lấy số từ YouTube Data API y như kênh đối thủ — cùng
 * kho `competitor_channels` (mốc số liệu, video, tăng trưởng) — rồi gom theo bộ máy: văn phòng (chi nhánh) →
 * phòng → nhóm → người phụ trách. Bảng `office_channel_links` nối mã kênh công ty với dòng kho ấy; dòng được
 * nối không bị xoá khi người theo dõi đối thủ bỏ kênh, và lượt chạy nền hằng đêm cập nhật cả kênh được nối.
 */
/** Số tuần gửi lên để tính view tuần (tuần này + 7 tuần trước). */
export const OFFICE_RESEARCH_WEEKS = 8;
/** Một lượt «Phân tích» tối đa chừng này kênh — mỗi kênh tốn ~10 đơn vị hạn mức YouTube. */
export const OFFICE_ANALYZE_BATCH_LIMIT = 60;
/** Số video lấy về mỗi kênh công ty — đủ cho «video tuần này» và video mới nhất, không ngốn hạn mức. */
export const OFFICE_VIDEO_LIMIT = 200;
export const officeWeekSchema = z.object({
    /** «DD/MM/YYYY» của Chủ nhật mở đầu tuần — khoá cột như bảng Thị trường. */
    key: z.string().trim().min(1).max(12),
    /** Thời điểm mở đầu tuần (ISO). */
    weekStart: z.string().trim().min(1).max(40),
});
export const officeStatsRequestSchema = z.object({
    weeks: z.array(officeWeekSchema).max(16),
});
export const officeAnalyzeRequestSchema = z.object({
    codes: z
        .array(z.string().trim().min(1).max(100))
        .min(1, 'Chưa chọn kênh nào')
        .max(OFFICE_ANALYZE_BATCH_LIMIT, `Mỗi lượt tối đa ${OFFICE_ANALYZE_BATCH_LIMIT} kênh`),
    weeks: z.array(officeWeekSchema).max(16),
});
export const officeChannelParamsSchema = z.object({
    code: z.string().trim().min(1).max(100),
});
//# sourceMappingURL=office-research.js.map